module.exports = __webpack_public_path__ + "static/media/bored.425c31be.png";